export const MAIN_ITEM_TYPE_VALUES = {
  FEATURED_VIDEO: 1,
  CHANNEL_COVER: 2,
};



// WEBPACK FOOTER //
// ./~/wix-vod-shared/src/app-settings/constants/main-item-type-values.js